import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Icon } from '@codex-brightworld/icons';

const Line = styled.div`
  width: 100%;
  height: 5px;
  background-color: transparent;
  border-radius: 2px;
`;

export const TabWrapper = styled.li`
  position: relative;
  flex: 1;
  display: flex;
  flex-flow: column;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${props => props.theme.colors.neutral.grey[2]};
  background-color: ${props => props.theme.colors.neutral.white};
  text-align: center;
  cursor: default;
  color: ${props => props.theme.colors.neutral.currysBlack};
  transition: background-color 0.2s ease, border-color 0.2s ease;
  font-family: ${({ theme }) => theme.fonts.default.fontFamily};
  font-size: 18px;

  svg path:last-child {
    fill: ${props => props.theme.colors.neutral.currysBlack};
  }

  &:hover {
    cursor: pointer;
  }

  ${props => !props.active && css`
    &:hover {
      color: ${props.theme.colors.primary.purple};
      svg path:last-child {
        fill: ${props.theme.colors.primary.purple};
      }
    }
  `};

  ${props => props.active && css`
    color: ${props.theme.colors.primary.purple};

    svg path:last-child {
      fill: ${props.theme.colors.primary.purple};
    }

    ${Line} {
      background-color: ${props.theme.colors.primary.purple};
    }
  `};
`;

export const TabActiveBorder = styled.div`
  position: absolute;
  top: -1px;
  right: -1px;
  left: -1px;
  height: 5px;
`;

const Ico = styled(Icon)`
  margin-right: 8px;
`;

const Text = styled.div`
  padding: ${props => `${props.theme.spacing[3]}`};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default function Tab(props) {
  return props.renderTab(TabWrapper, TabActiveBorder, props);
}

Tab.displayName = 'Tab';

Tab.propTypes = {
  className: PropTypes.string,
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  children: PropTypes.node,
  renderTab: PropTypes.func,
  icon: PropTypes.string
};

Tab.defaultProps = {
  className: undefined,
  active: false,
  disabled: false,
  children: undefined,
  renderTab: (DefaultTabWrapper, DefaultTabActiveBorder, props) => (
    <DefaultTabWrapper {...props}>
      <Text>
        {props.icon && <Ico icon={props.icon} />}
        {props.active && <DefaultTabActiveBorder />}
        {props.children}
      </Text>
      <Line />
    </DefaultTabWrapper>
  )
};
